// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isSubscriptionGroupsResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      name: maybe(string, true),
      channel: number,
      desc: maybe(string, true),
      ext_id: string,
      ag_id: string,
      // there are definitely more fields here, but they have the potential to differ by channel
    })
  ),
});
